// React imports.
import React, { Component } from "react";

// App imports.


const IntroPage4 = ({ state }) => (
  <div >
    <h2>Measure #2: Burden Reduction Targeting Index</h2>
    <br />
    <p>The <strong>Burden Reduction Targeting Index</strong> tells you whether or not, on average, you are paying a greater portion of the energy bill for higher burden households than for all households receiving LIHEAP bill payment assistance.&nbsp; </p>

    <table className="inlineTable" style={{ "width": "80%" }} ><tbody>
      <tr>
        <td>
          <i>Burden Reduction Targeting Index</i> =
        </td>
        <td>
          <div style={{ "textAlign": "center" }}>
            <i>% Burden Reduction Due to LIHEAP (High Burden Households)</i>
            <hr />
            <i>% Burden Reduction Due to LIHEAP (All Households)</i>
          </div>
        </td>
        <td>
          × 100
        </td>
      </tr>
    </tbody></table>
    <br />
    <div className="takeaways" >
      <p><strong>Key Takeaways:</strong></p>
      <ul>
        <li>The higher the <strong>Burden Reduction Targeting Index</strong> value, the better you are doing at targeting benefits such that you are paying a greater portion of the energy bill for higher burden households.
          <br /><br />
        </li>
        <li>Having a high <strong>Burden Reduction Targeting Index</strong> value is important because the LIHEAP Statute requires that grantees furnish the highest level of assistance to households with the lowest incomes and highest energy costs or needs.</li>
      </ul>
    </div>




    <br />
    <p > Please click <em>Next </em>to continue.</p>


  </div>
);

export default IntroPage4;
